<onsip-header-main>
  <onsip-header-page-title>{{ "ONSIP_I18N.DIRECTORY" | translate }}</onsip-header-page-title>
</onsip-header-main>
<onsip-loading-container [deferCond]="isDataObtained$">
  <onsip-header-main>
    @if (hasDestinations | async) {
    <onsip-header-action-bar>
      <mat-form-field appearance="outline">
        <input [formControl]="search" [placeholder]="'Search'" autocomplete="off" matInput />
        <mat-icon color="primary" matSuffix>search</mat-icon>
      </mat-form-field>
      <button
        mat-stroked-button
        onsip-header-secondary-action
        type="button"
        (click)="openDownloadModal()"
        color="primary"
      >
        {{ "ONSIP_I18N.DOWNLOAD_DIRECTORY" | translate }}
      </button>
    </onsip-header-action-bar>
    }
  </onsip-header-main>
  @if (hasDestinations | async) {
  <onsip-table-two
    class="directories-table"
    [dataSource]="dataSource"
    [useGrid]="true"
    matSort
    multiTemplateDataRows
  >
    <!-- Sip Address -->
    <ng-container matColumnDef="sipAddress">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.SIP_ADDRESS" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let directory">
        <span class="text-ellipsis">
          {{ directory.sipAddress }}
        </span>
      </mat-cell>
    </ng-container>
    <!-- Name -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.NAME" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let directory">
        <span class="text-ellipsis">
          {{ directory.name }}
        </span>
      </mat-cell>
    </ng-container>
    <!-- Extensions -->
    <ng-container matColumnDef="extensions">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.EXTENSIONS" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let directory">
        <span class="text-ellipsis">{{
          (directory?.extensions | formatExtensions).join(", ")
        }}</span>
      </mat-cell>
    </ng-container>
    <!-- Phone numbers -->
    <ng-container matColumnDef="phoneNumbers">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.PHONE_NUMBERS" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let directory">
        <div class="text-ellipsis">
          @for (phone of directory?.phoneNumbers; track phone) {
          <div>{{ phone | e164 }}</div>
          }
        </div>
      </mat-cell>
    </ng-container>
    <!-- Address Type -->
    <ng-container matColumnDef="addressType">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{
        "ONSIP_I18N.ADDRESS_TYPE" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let directory">
        @if (directory.link?.length) {
        <span class="text-ellipsis">
          <a [routerLink]="[directory.link]" class="address-type-link">{{
            directory.addressType
          }}</a>
        </span>
        } @else {
        <span class="text-ellipsis">{{ directory.addressType }}</span>
        }
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    <div *matNoDataRow class="no-data-row">
      @if ( (search.value?.length && dataSource.data.length) || (!search.value?.length &&
      !dataSource.data.length) ) {
      <span>
        {{ "ONSIP_I18N.NO_RESULTS" | translate }}
      </span>
      }
    </div>
  </onsip-table-two>
  <mat-paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons
    onsip-paginator-primary-icon
  >
  </mat-paginator>
  <span class="mat-body-2"
    >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a [routerLink]="views.CONTACT_SUPPORT" class="support-link">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </span>
  }
</onsip-loading-container>
